/**
 * Positions and sizes .main-menu relative to the height of .location-menu
 * on screens narrower than 769px.
 *   top:    calc(100% - <locationMenuHeight>px)
 *   height: calc(100vh - <locationMenuHeight>px)
 *
 * Overrides any other script that sets an inline height on .main-menu:
 * the values live in a stylesheet rule with !important, which beats inline
 * styles that aren't !important, no matter when the other script runs.
 *
 * If .location-menu isn't on the page, nothing changes and the existing
 * height script works as before. At 769px and up, the override is removed.
 */
(function () {
  'use strict';

  const ACTIVE_CLASS = 'has-location-menu-offset';
  const HEIGHT_VAR = '--location-menu-height';

  function injectStyles() {
    if (document.getElementById('location-menu-offset-styles')) return;

    const style = document.createElement('style');
    style.id = 'location-menu-offset-styles';
    style.textContent = `
      @media (max-width: 768px) {
        .main-menu.${ACTIVE_CLASS} {
          top: calc(100% - var(${HEIGHT_VAR}, 0px)) !important;
          height: calc(100vh - var(${HEIGHT_VAR}, 0px)) !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function init() {
    const locationMenu = document.querySelector('.location-menu');
    const mainMenu = document.querySelector('.main-menu');

    // No location menu: leave the existing height script in charge
    if (!locationMenu || !mainMenu) return;

    injectStyles();

    const mobileQuery = window.matchMedia('(max-width: 768px)');

    function update() {
      if (mobileQuery.matches) {
        const locationMenuHeight = locationMenu.getBoundingClientRect().height;
        mainMenu.style.setProperty(HEIGHT_VAR, `${locationMenuHeight}px`);
        mainMenu.classList.add(ACTIVE_CLASS);
      } else {
        mainMenu.classList.remove(ACTIVE_CLASS);
        mainMenu.style.removeProperty(HEIGHT_VAR);
      }
    }

    update();

    // Re-run when crossing the 768/769px breakpoint
    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', update);
    } else {
      mobileQuery.addListener(update); // Older Safari
    }

    if ('ResizeObserver' in window) {
      // Fires on any size change of .location-menu (font load, content wrap, etc.)
      new ResizeObserver(update).observe(locationMenu);
    } else {
      // Fallback for older browsers
      let frame;
      window.addEventListener('resize', function () {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(update);
      });
      window.addEventListener('load', update);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();